import { render, staticRenderFns } from "./WidgetCreate.vue?vue&type=template&id=3797d0fd&"
import script from "./WidgetCreate.vue?vue&type=script&lang=ts&"
export * from "./WidgetCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports